import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RequirementApiResponse, RequirementRecordResponse } from "../model/requirement.model";
import { RequirementApprovalResponse, RequirementDecisionRequest, RequirementHistoryResponse, RequirementRequiredDecisionRequest } from "../model/requirement-workflow.model";
import { BASE_PATH } from "../variables";

@Injectable({ providedIn: "root" })
export class StaffRequirementWorkflowService {
  private readonly requirementsUrl: string;

  constructor(private readonly http: HttpClient, @Inject(BASE_PATH) basePath: string) {
    this.requirementsUrl = `${basePath.replace(/\/$/, "")}/api/v1/requirements`;
  }

  submit(id: number): Observable<RequirementApiResponse<RequirementRecordResponse>> {
    return this.http.post<RequirementApiResponse<RequirementRecordResponse>>(`${this.requirementsUrl}/${id}/submit`, null);
  }

  resubmit(id: number): Observable<RequirementApiResponse<RequirementRecordResponse>> {
    return this.http.post<RequirementApiResponse<RequirementRecordResponse>>(`${this.requirementsUrl}/${id}/resubmit`, null);
  }

  approve(id: number, request?: RequirementDecisionRequest): Observable<RequirementApiResponse<RequirementRecordResponse>> {
    return this.http.post<RequirementApiResponse<RequirementRecordResponse>>(`${this.requirementsUrl}/${id}/approve`, request ?? null);
  }

  observe(id: number, request: RequirementRequiredDecisionRequest): Observable<RequirementApiResponse<RequirementRecordResponse>> {
    return this.http.post<RequirementApiResponse<RequirementRecordResponse>>(`${this.requirementsUrl}/${id}/observe`, request);
  }

  reject(id: number, request: RequirementRequiredDecisionRequest): Observable<RequirementApiResponse<RequirementRecordResponse>> {
    return this.http.post<RequirementApiResponse<RequirementRecordResponse>>(`${this.requirementsUrl}/${id}/reject`, request);
  }

  cancel(id: number, request?: RequirementDecisionRequest): Observable<RequirementApiResponse<RequirementRecordResponse>> {
    return this.http.post<RequirementApiResponse<RequirementRecordResponse>>(`${this.requirementsUrl}/${id}/cancel`, request ?? null);
  }

  listApprovals(id: number): Observable<RequirementApiResponse<readonly RequirementApprovalResponse[]>> {
    return this.http.get<RequirementApiResponse<readonly RequirementApprovalResponse[]>>(`${this.requirementsUrl}/${id}/approvals`);
  }

  listHistory(id: number): Observable<RequirementApiResponse<readonly RequirementHistoryResponse[]>> {
    return this.http.get<RequirementApiResponse<readonly RequirementHistoryResponse[]>>(`${this.requirementsUrl}/${id}/history`);
  }
}
